import FaqForm from "./FaqForm";

export default function EditFaq() {
  return <FaqForm mode="edit" />;
}
